import { createSlice } from "@reduxjs/toolkit";

const sessionFormatInitState = {
  isLoading: false,
  sessionFormats: [],
  sessionFormat: {},
  exerciseFormats: [],
  sessionDetails: {},
  formatCategories: [],
  exerciseCategory: [],
  sessionData: {},
  formats: {},
};

const sessionFormatReducerSlice = createSlice({
  name: "sessionFormats",
  initialState: sessionFormatInitState,
  reducers: {
    saveSessionDetails: (state, action) => {
      state.sessionDetails = action.payload;
    },
    addFormatState: (state, action) => {
      state.exerciseFormats.unshift(action.payload);
      state.isLoading = false;
    },

    saveSubmittedData: (state, action) => {
      state.formats = action.payload;
    },
    updateSessionData: (state, action) => {
      state.sessionData = action.payload;
    },
    setSessionFormatCategoryState: (state, action) => {
      state.formatCategories = action.payload.formatCategories || state.formatCategories;
      state.isLoading = false;
    },
    setExercisesByCategory: (state, action) => {
      state.exerciseCategory = action.payload.exerciseCategory || state.exerciseCategory;
      state.isLoading = false;
    },
    setFormatSessionById: (state, action) => {
      state.sessionFormats = action.payload;
      state.isLoading = false;
    },
    setFormatSessionId: (state, action) => {
      state.sessionFormat = action.payload;
      state.isLoading = false;
    },
    deleteSessionFormatState: (state, action) => {
      state.sessionFormats = state.sessionFormats.filter(
        (sessionFormat) => sessionFormat._id !== action.payload
      );
      state.isLoading = false;
    },
    editSessionFormatState: (state, action) => {
      state.sessionFormats = state.sessionFormats.map((sessionFormat) => {
        if (action.payload._id === sessionFormat._id) {
          sessionFormat = action.payload;
        }
        return sessionFormat;
      });
      state.isLoading = false;
    },
  },
});

export const {
  saveSubmittedData,
  saveSessionDetails,
  setSessionFormatCategoryState,
  setExercisesByCategory,
  updateSessionData,
  addFormatState,
  setFormatSessionById,
  setFormatSessionId,
  deleteSessionFormatState,
  editSessionFormatState,
} = sessionFormatReducerSlice.actions;

export default sessionFormatReducerSlice.reducer;
